import { Delete as DeleteIcon } from "@mui/icons-material";
import { Edit as EditIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import type { MenuOptionType } from "../../../../../controls/contextMenu/models/MenuOptionType";
import type { CatalogTundishShroud } from "../../../models/CatalogTundishShroud";
type Props = {
  setTundishShroud: (tS: CatalogTundishShroud) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  handleNewTundishShroud: () => void;
};
export const useTundishOptionsFunctions = ({
  setTundishShroud,
  setShowModal,
  handleNewTundishShroud,
}: Props) => {
  const getMenuOptions = (data: CatalogTundishShroud) => {
    let options: MenuOptionType[] = [
      {
        name: "New T-Shroud",
        key: "new_tundish_shroud",
        onClick: () => {
          handleNewTundishShroud();
        },
        icon: <PlaylistAddIcon />,
      },
    ];
    if (data) {
      options = options.concat([
        {
          name: "Edit T-Shroud",
          key: "edit_tundish_shroud",
          onClick: () => {
            setTundishShroud(data);
            setShowModal("edit");
          },
          icon: <EditIcon />,
        },
        {
          name: "Delete T-Shroud",
          key: "delete_tundish_shroud",
          onClick: () => {
            setTundishShroud(data);
            setShowModal("delete");
          },
          icon: <DeleteIcon />,
        },
      ]);
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
